// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomButton_wrapper__X03c4","green":"CustomButton_green__FFIp2","red":"CustomButton_red__YxMbD"};